<template>
    <div>
        <div class="mx-4 sm:mx-0 flex justify-between items-end capitalize">
            <div class="text-2xl">{{ value }}</div>

            <ul v-if="word && word.signs && word.signs.length > 1" class="flex text-sm space-x-1 overflow-auto">
                <li v-for="sign in word.signs" :key="sign.name" @click="selectSign(sign)" class="transition-colors px-3 rounded-t-md pt-2 pb-1.5 cursor-pointer" :class="{'bg-blue-300 hover:bg-blue-400': sign == selectedSign, 'bg-gray-200 hover:bg-gray-300': sign != selectedSign}">
                    {{ sign.name }}
                </li>
            </ul>

            <!-- <select v-if="word.signs.length > 1" v-model="selectedSign" class="mt-1 block w-32 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"> -->
            <!--     <option v-for="(sign, index) in word.signs" :value="index">{{ sign.name }}</option> -->
            <!-- </select> -->
        </div>

        <div v-if="word && selectedSign" class="bg-white overflow-hidden shadow-sm sm:rounded-lg flex" :class="{'sm:rounded-tr-none': word.signs.length > 1}">
            <ul class="bg-gray-50 divide-y-2 divide-gray-100">
                <li v-for="display in selectedSign.displays"
                    v-show="display.exists()" @click="selectedDisplay = display"
                    :title="display.name"
                    class="transition-colors cursor-pointer p-3 text-white"
                    :class="display == selectedDisplay ? 'bg-blue-300 hover:bg-blue-400' : 'bg-gray-200 hover:bg-gray-300'">

                    <i :class="display.iconClass"></i>
                </li>
            </ul>
            <word-display v-if="selectedDisplay" :value="selectedDisplay"></word-display>
        </div>
        <alert v-else-if="word" :title="'Ordet [' + value + '] har ikke noen visning'" danger>
            <ul role="list" class="list-disc pl-5 space-y-1">
                <li>Prøv å skrive inn et synonym</li>
                <li>Prøv å omformuler setningen</li>
            </ul>
        </alert>
        <!-- This example requires Tailwind CSS v2.0+ -->
        <alert v-else>
            <p>Vi laster dette ordet</p>
        </alert>
    </div>
    <!-- <pre v-if="word">{{ word.signs }}</pre> -->

</template>

<script>
import Word from '../Classes/Models/Word';

export default {
    props: {
        value: {
            required: true,
        },
    },

    data() {
        return {
            word: null,
            selectedSign: null,
            selectedDisplay: null,
        }
    },

    watch: {
        value() {
            this.load();
        },
    },

    mounted() {
        this.load();
    },

    methods: {
        async load() {
            this.word = null;

            this.word = await Word.find(this.value);
            this.selectSign(this.word.signs[0]);
        },

        selectSign(sign) {
            this.selectedSign = null;
            this.selectedDisplay = null;
            this.selectedSign = sign;

            this.selectedDisplay = this.selectedSign.displays.find(display => display.path);
        }
    }
}
</script>
